export const appIdTooltipText = [
  `The App ID is the unique identifier for your new Application, make sure to choose a unique & memorable one.`,
  `You can choose your App ID only once.(You cannot modify your App ID once chosen.)`,
  `App ID must be 1 to 32 letters or numbers in length, with hyphens or underscores as separators (spaces, periods, etc are not allowed).`,
];

export const selectedBaseWorkflowTooltipText = `
When you add an input to your app, the base workflow of your app computes the outputs from the model(s) in that workflow and 
indexes those outputs. Those indexed outputs enable search and transfer-learn based training on top of the base workflow model(s).`;
